module.exports = __webpack_public_path__ + "static/img/2_1_1.0a27bb49.png";